import React from "react";

/**
 * "Continue with Google" button.
 *
 * We use a plain anchor to the backend's `/api/auth/google/start` endpoint
 * (NOT a fetch) because Google OAuth needs a full browser navigation — the
 * backend immediately 302-redirects to Google. Credentials are HttpOnly
 * cookies set by the callback, so no fetch wiring is needed on the frontend.
 */
export function GoogleAuthButton({ next = "/app", label = "Continue with Google", testId = "google-auth-button" }) {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    const href = `${base}/api/auth/google/start?next=${encodeURIComponent(next)}`;
    return (
        <a
            href={href}
            data-testid={testId}
            className="w-full inline-flex items-center justify-center gap-3 h-11 rounded-xl border border-sand-300 bg-white text-ocean-700 font-medium hover:bg-sand-50 transition-colors shadow-sm"
        >
            <GoogleGlyph />
            <span>{label}</span>
        </a>
    );
}

function GoogleGlyph() {
    return (
        <svg aria-hidden="true" width="18" height="18" viewBox="0 0 48 48" className="shrink-0">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.9 32.7 29.4 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
            <path fill="#FF3D00" d="M6.3 14.1l6.6 4.8C14.7 15.2 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.1 29.4 4 24 4 16.3 4 9.6 8.3 6.3 14.1z" />
            <path fill="#4CAF50" d="M24 44c5.3 0 10.1-2 13.7-5.4l-6.3-5.2C29.3 35 26.8 36 24 36c-5.4 0-9.9-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" />
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2.2-2 4.1-3.8 5.4l6.3 5.2c-.4.3 6.7-4.9 6.7-14.6 0-1.3-.1-2.4-.4-3.5z" />
        </svg>
    );
}

export default GoogleAuthButton;
